/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_InviteInputs */

const en_us2_clubs_invite = /** @type {(inputs: Clubs_InviteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invite`)
};

const pt_br2_clubs_invite = /** @type {(inputs: Clubs_InviteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convidar`)
};

const es_419_clubs_invite = /** @type {(inputs: Clubs_InviteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invitar`)
};

const pt_pt2_clubs_invite = /** @type {(inputs: Clubs_InviteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convidar`)
};

const fr_fr2_clubs_invite = /** @type {(inputs: Clubs_InviteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inviter`)
};

const de_de2_clubs_invite = /** @type {(inputs: Clubs_InviteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einladen`)
};

const it_it2_clubs_invite = /** @type {(inputs: Clubs_InviteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invita`)
};

/**
* | output |
* | --- |
* | "Invite" |
*
* @param {Clubs_InviteInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_invite = /** @type {((inputs?: Clubs_InviteInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_InviteInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_invite(inputs)
	if (locale === "es-419") return es_419_clubs_invite(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_invite(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_invite(inputs)
	if (locale === "de-DE") return de_de2_clubs_invite(inputs)
	if (locale === "it-IT") return it_it2_clubs_invite(inputs)
	return en_us2_clubs_invite(inputs)
});
export { clubs_invite as "clubs.invite" }